// Central content source for Sundrop Infotech

export const COMPANY = {
  name: "Sundrop Infotech",
  legal: "Sundrop Infotech Pvt Ltd",
  phone: "7507178593",
  phoneDisplay: "+91 75071 78593",
  email: "enosh@sundropinfotech.com",
  since: "2016",
  address:
    "B-5/401, Fortune East, Near Hyundai Showroom, Kharadi Bypass Road, Kirkee (CB), Pune City, Pune, 411014",
  cities: ["Pune", "Mumbai", "Bangalore", "Gujarat"],
  tagline: "Mechanised. Managed. Meticulous.",
};

export const STATS = [
  { value: "2016", label: "Serving since" },
  { value: "4", label: "Cities covered" },
  { value: "6", label: "Service verticals" },
  { value: "9+", label: "Sectors served" },
];

export const SERVICES = [
  {
    id: "housekeeping",
    index: "01",
    icon: "Sparkles",
    title: "Housekeeping & Janitorial",
    short: "Machine-led deep cleaning and daily upkeep engineered for spotless spaces.",
    tagline: "Automated. Mechanised. Immaculate.",
    image:
      "https://images.pexels.com/photos/6195122/pexels-photo-6195122.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
    overview:
      "We replace guesswork with machines. Our housekeeping and janitorial division blends trained manpower with automated scrubbers, ride-on sweepers, high-pressure jets and modern chemistry to deliver hygiene you can measure.",
    paragraphs: [
      "Sundrop's housekeeping is built around mechanised cleaning rather than manual labour alone. Auto-scrubber driers, single-disc machines, vacuum systems and colour-coded consumables ensure consistent, hospital-grade results across every shift.",
      "From daily upkeep to periodic deep-cleaning cycles, our supervisors run checklists, audits and defined SOPs so quality never depends on who showed up that day. Every site gets a tailored cleaning matrix mapped to footfall and criticality.",
    ],
    features: [
      "Automated scrubbers, sweepers & high-pressure systems",
      "Colour-coded tools to prevent cross-contamination",
      "Deep-cleaning & periodic sanitisation cycles",
      "Trained supervisors with audit checklists",
      "Eco-conscious chemicals & waste segregation",
    ],
  },
  {
    id: "security",
    index: "02",
    icon: "ShieldCheck",
    title: "Security Services",
    short: "Trained, vetted security personnel backed by process and vigilance.",
    tagline: "Alert. Disciplined. Dependable.",
    image:
      "https://images.pexels.com/photos/35562107/pexels-photo-35562107.png?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400",
    overview:
      "Our security teams are screened, trained and supervised to protect people, premises and assets around the clock with a calm, professional presence.",
    paragraphs: [
      "Every guard is background-verified, uniformed and drilled on access control, visitor management, patrolling and emergency response. We deploy the right ratio for your risk profile, not a one-size template.",
      "Field officers conduct surprise checks, maintain registers and coordinate with your teams, giving you a security layer that is visible, accountable and responsive.",
    ],
    features: [
      "Background-verified & trained guards",
      "Access control & visitor management",
      "Patrolling, registers & incident reporting",
      "Emergency response protocols",
      "Supervisory audits & night rounds",
    ],
  },
  {
    id: "healthcare",
    index: "03",
    icon: "HeartPulse",
    title: "Healthcare Professionals",
    short: "Patient-care attendants, nurses and NABH-standard hospital hygiene.",
    tagline: "Compassionate. Clinical. Compliant.",
    image:
      "https://images.unsplash.com/photo-1519494026892-80bbd2d6fd0d?auto=format&fit=crop&q=80&w=1400",
    overview:
      "We staff hospitals and care facilities with trained patient-care attendants and nurses, and maintain hospital hygiene aligned to NABH standards.",
    paragraphs: [
      "Our healthcare workforce includes patient-care attendants and qualified nurses who assist with day-to-day patient support, mobility, monitoring and comfort under clinical supervision.",
      "On the hygiene side, we maintain hospital environments to NABH benchmarks - infection-control protocols, colour-coded cleaning, biomedical waste awareness and documented sanitation cycles across critical and general areas.",
    ],
    features: [
      "Trained patient-care attendants & nurses",
      "NABH-aligned hospital hygiene protocols",
      "Infection control & biomedical waste awareness",
      "Colour-coded, zone-wise sanitation",
      "Supervised, documented cleaning cycles",
    ],
  },
  {
    id: "technical",
    index: "04",
    icon: "Wrench",
    title: "Multi-Skill Technical Workforce",
    short: "Carpenters, plumbers and HVAC / maintenance specialists on demand.",
    tagline: "Skilled. Versatile. On-site.",
    image:
      "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?auto=format&fit=crop&q=80&w=1400",
    overview:
      "Keep your facility running with our multi-skilled technical teams - from carpentry and plumbing to HVAC and general maintenance departments.",
    paragraphs: [
      "We provide deployable technicians who handle breakdowns and preventive maintenance across building services. One partner for carpentry, plumbing, electrical support and HVAC upkeep reduces your vendor sprawl.",
      "Teams work to planned preventive-maintenance schedules with logs and escalation paths, so small issues never become expensive failures.",
    ],
    features: [
      "Carpenters, plumbers & general technicians",
      "HVAC operation & maintenance support",
      "Preventive & breakdown maintenance",
      "Maintenance logs & escalation workflow",
      "Flexible on-site or on-call deployment",
    ],
  },
  {
    id: "industrial",
    index: "05",
    icon: "Factory",
    title: "Industrial Workforce",
    short: "Forklift drivers, CNC operators, welders and fitters for the shop floor.",
    tagline: "Certified. Productive. Safe.",
    image:
      "https://images.unsplash.com/photo-1730584474196-b0e8a29303e8?auto=format&fit=crop&q=80&w=1400",
    overview:
      "We supply skilled industrial manpower for manufacturing and logistics - forklift drivers, CNC machine operators, welders and turners / fitters.",
    paragraphs: [
      "Our industrial pool is skill-tested and safety-oriented, ready to plug into your production and material-handling operations without a long ramp-up.",
      "We handle sourcing, verification and deployment so you get reliable hands on the line, while your supervisors focus on output and quality.",
    ],
    features: [
      "Forklift & material-handling operators",
      "CNC machine operators",
      "Welders (MIG/TIG/ARC)",
      "Turners / fitters",
      "Safety-first, skill-tested deployment",
    ],
  },
  {
    id: "corporate",
    index: "06",
    icon: "Building2",
    title: "Corporate Facility Services",
    short: "Pantry, janitorial, facade cleaning, guest-house & parking management.",
    tagline: "Polished. Seamless. Corporate-ready.",
    image:
      "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?auto=format&fit=crop&q=80&w=1400",
    overview:
      "A complete facility bouquet for corporate campuses - pantry services, janitorial, facade cleaning, guest-house management and parking management.",
    paragraphs: [
      "We run the everyday experience of your workplace: courteous pantry staff, spotless washrooms and floors, and well-kept common areas that reflect your brand to every visitor.",
      "Beyond the basics we manage high-rise facade cleaning, guest-house hospitality and organised parking - so your admin team gets one accountable partner for the whole campus.",
    ],
    features: [
      "Pantry & office-support services",
      "Corporate janitorial & washroom hygiene",
      "High-rise facade cleaning",
      "Guest-house management",
      "Parking management & traffic flow",
    ],
  },
];

export const SECTORS = [
  {
    name: "Education",
    detail: "Schools, colleges & universities",
    image:
      "https://images.unsplash.com/photo-1562774053-701939374585?auto=format&fit=crop&q=80&w=1200",
  },
  {
    name: "Corporate Offices",
    detail: "Campuses & business parks",
    image:
      "https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=1200",
  },
  {
    name: "Industrial Manufacturing",
    detail: "Plants & production units",
    image:
      "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?auto=format&fit=crop&q=80&w=1200",
  },
  {
    name: "Malls",
    detail: "Shopping & entertainment",
    image:
      "https://images.unsplash.com/photo-1519567241046-7f570eee3ce6?auto=format&fit=crop&q=80&w=1200",
  },
  {
    name: "Pharmaceuticals",
    detail: "Clean-room grade upkeep",
    image:
      "https://images.unsplash.com/photo-1587854692152-cbe660dbde88?auto=format&fit=crop&q=80&w=1200",
  },
  {
    name: "Retail",
    detail: "Stores & showrooms",
    image:
      "https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&q=80&w=1200",
  },
  {
    name: "Public Sector",
    detail: "Government & civic spaces",
    image:
      "https://images.unsplash.com/photo-1555848962-6e79363ec58f?auto=format&fit=crop&q=80&w=1200",
  },
  {
    name: "Resorts",
    detail: "Hospitality & leisure",
    image:
      "https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?auto=format&fit=crop&q=80&w=1200",
  },
];

export const MANIFESTO = [
  {
    num: "01",
    title: "Mechanised over manual",
    body: "We invest in machines, tools and modern chemistry so results are consistent, faster and measurable - not dependent on a single day's effort.",
  },
  {
    num: "02",
    title: "Process before people",
    body: "Every site runs on SOPs, checklists and audits. Supervision is built in, so quality is a system - not a promise.",
  },
  {
    num: "03",
    title: "One partner, many skills",
    body: "Housekeeping, security, healthcare, technical and industrial workforce under one roof means fewer vendors and one point of accountability.",
  },
  {
    num: "04",
    title: "Standards that hold up",
    body: "From NABH-aligned hospital hygiene to safety-first industrial deployment, we work to the benchmarks your sector demands.",
  },
];
